import React, { useState } from 'react';
import { APP_VERSION } from '../version';

interface AboutPageProps {
  onClose: () => void;
  apkUrl?: string;
}

// Icônes SVG modernes
const Icons = {
  shield: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    </svg>
  ),
  cloud: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
    </svg>
  ),
  offline: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414" />
    </svg>
  ),
  users: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
    </svg>
  ),
  ruler: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5" />
    </svg>
  ),
  phone: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  android: (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M17.523 15.3414c-.5511 0-.9978-.4467-.9978-.9978 0-.5511.4467-.9978.9978-.9978.5511 0 .9978.4467.9978.9978 0 .5511-.4467.9978-.9978.9978zm-11.046 0c-.5511 0-.9978-.4467-.9978-.9978 0-.5511.4467-.9978.9978-.9978.5511 0 .9978.4467.9978.9978 0 .5511-.4467.9978-.9978.9978zm11.4045-6.02l1.9973-3.4592c.1111-.1921.0451-.4376-.147-.5487-.192-.1111-.4375-.0451-.5486.147L17.1517 8.889c-1.5457-.7049-3.2644-1.1017-5.0717-1.1017-1.8073 0-3.526.3968-5.0717 1.1017l-1.9803-3.4293c-.1111-.192-.3566-.258-.5487-.147-.1921.1111-.2581.3566-.147.5487l1.9973 3.4592C3.1206 10.9575 1 13.7225 1 16.9242h22.16c0-3.2017-2.1206-5.9667-5.324-7.6028z" />
    </svg>
  ),
  download: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
    </svg>
  ),
  sparkles: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    </svg>
  ),
  chevronDown: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  ),
  check: (
    <svg className="w-5 h-5 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
    </svg>
  ),
  star: (
    <svg className="w-5 h-5 text-amber-400" fill="currentColor" viewBox="0 0 20 20">
      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
  ),
  dashboard: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  ),
  bell: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
    </svg>
  ),
  clipboard: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
    </svg>
  ),
};

// Composant FAQ Accordéon
const FAQItem: React.FC<{ question: string; answer: string }> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border-b border-gray-100 last:border-0">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between py-4 text-left hover:bg-gray-50 transition-colors rounded-lg px-3 -mx-3"
      >
        <span className="font-medium text-gray-800">{question}</span>
        <span className={`transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
          {Icons.chevronDown}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-4' : 'max-h-0'}`}>
        <p className="text-gray-600 text-sm leading-relaxed px-3">{answer}</p>
      </div>
    </div>
  );
};

// Composant Carte de fonctionnalité avec animations
const FeatureCard: React.FC<{ icon: React.ReactNode; title: string; description: string }> = ({ icon, title, description }) => (
  <div className="group relative bg-gradient-to-br from-white to-gray-50 rounded-2xl p-5 border border-gray-100 shadow-sm hover:shadow-xl hover:border-blue-300 hover:-translate-y-2 transition-all duration-500 cursor-default overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 to-indigo-50/50 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
    <div className="absolute -right-8 -bottom-8 w-24 h-24 bg-gradient-to-br from-blue-400/10 to-indigo-500/10 rounded-full opacity-0 group-hover:opacity-100 group-hover:scale-150 transition-all duration-700" />
    <div className="relative">
      <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white shadow-lg shadow-blue-500/25 mb-4 group-hover:scale-110 group-hover:rotate-3 transition-all duration-500">
        {icon}
      </div>
      <h4 className="font-semibold text-gray-800 mb-2 group-hover:text-blue-700 transition-colors duration-300">{title}</h4>
      <p className="text-sm text-gray-600 leading-relaxed">{description}</p>
    </div>
  </div>
);

// Composant Forfait avec animations - Cliquable vers /abonnement
const PlanCard: React.FC<{ name: string; price: string; features: string[]; highlight?: boolean; promo?: string }> = ({ name, price, features, highlight, promo }) => (
  <a
    href="/abonnement"
    className={`group relative rounded-2xl p-5 pt-8 border transition-all duration-500 hover:-translate-y-2 hover:shadow-xl cursor-pointer block ${highlight ? 'border-blue-300 bg-gradient-to-br from-blue-50 to-indigo-50 shadow-lg' : 'border-gray-200 bg-white hover:border-blue-200'}`}
  >
    {/* Effet de fond au hover */}
    <div className={`absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 ${highlight ? 'bg-gradient-to-br from-blue-100/50 to-indigo-100/50' : 'bg-gradient-to-br from-gray-50 to-blue-50/30'}`} />
    {promo && (
      <div className="absolute top-0 right-4 -translate-y-1/2 animate-pulse z-10">
        <span className="px-3 py-1 bg-gradient-to-r from-amber-400 to-orange-500 text-white rounded-full text-xs font-bold shadow-lg">
          {promo}
        </span>
      </div>
    )}
    {highlight && (
      <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg z-10">
        Populaire
      </div>
    )}
    <div className="relative">
      <h4 className="font-bold text-lg text-gray-800 group-hover:text-blue-700 transition-colors duration-300">{name}</h4>
      <p className="text-2xl font-extrabold text-gray-900 mt-2 group-hover:scale-105 transition-transform duration-300 origin-left">{price}</p>
      <ul className="mt-4 space-y-2">
        {features.map((feature, i) => (
          <li key={i} className="flex items-start gap-2 text-sm text-gray-600 group-hover:text-gray-700 transition-colors" style={{ transitionDelay: `${i * 50}ms` }}>
            <span className="group-hover:scale-110 transition-transform duration-300">{Icons.check}</span>
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      <div className="mt-4 text-center">
        <span className={`inline-flex items-center gap-1 text-sm font-semibold ${highlight ? 'text-blue-600' : 'text-indigo-600'} group-hover:gap-2 transition-all`}>
          Voir l'offre
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </span>
      </div>
    </div>
  </a>
);

const AboutPage: React.FC<AboutPageProps> = ({ onClose, apkUrl }) => {
  const faqs = [
    {
      question: "Je ne vois pas le bouton \"Installer l'app\".",
      answer: "Sur iPhone/iPad, ouvrez le site dans Safari puis utilisez Partager → Sur l'écran d'accueil. Sur Android, ouvrez dans Chrome et utilisez le menu (⋮) → Ajouter à l'écran d'accueil."
    },
    {
      question: "Vais-je perdre mes données si je change de téléphone ?",
      answer: "Non ! Connectez-vous sur le nouveau téléphone avec le même compte, puis utilisez Synchroniser pour récupérer toutes vos données depuis le cloud."
    },
    {
      question: "L'application fonctionne-t-elle hors-ligne ?",
      answer: "Oui, absolument ! Vous pouvez consulter et modifier vos données sans connexion. Les changements seront automatiquement synchronisés dès que vous serez en ligne."
    },
    {
      question: "Le paiement est-il sécurisé ?",
      answer: "Oui, tous les paiements sont traités via FedaPay, une plateforme certifiée et sécurisée. Aucune donnée bancaire n'est stockée dans l'application."
    },
    {
      question: "Puis-je utiliser l'app sur plusieurs appareils ?",
      answer: "Oui ! Connectez-vous avec le même compte sur tous vos appareils. La synchronisation permet de partager vos données entre votre téléphone, tablette et ordinateur."
    },
    {
      question: "Comment mettre à jour l'application ?",
      answer: "L'application se met à jour automatiquement si vous l'utilisez dans le navigateur (PWA). Pour la version installée via APK, les mises à jour majeures nécessiteront de télécharger et d'installer la nouvelle version du fichier APK."
    }
  ];

  return (
    <div className="mx-auto w-full max-w-4xl px-4 py-6 md:px-6">
      {/* CSS Animations */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }
        @keyframes shimmer {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        @keyframes sparkle {
          0%, 100% { opacity: 0.4; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.3); }
        }
        @keyframes gradientMove {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
      `}</style>

      {/* En-tête moderne avec logo M animé */}
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 p-8 md:p-12 text-white shadow-2xl mb-8">
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 25% 25%, white 2%, transparent 2%), radial-gradient(circle at 75% 75%, white 2%, transparent 2%)', backgroundSize: '60px 60px' }} />
        <div className="relative">
          <div className="flex items-center gap-4 mb-4">
            {/* Logo M animé */}
            <div className="relative">
              <div
                className="absolute -inset-2 rounded-2xl opacity-75"
                style={{
                  background: 'linear-gradient(45deg, #fbbf24, #f59e0b, #fbbf24)',
                  backgroundSize: '300% 300%',
                  animation: 'gradientMove 3s ease infinite',
                }}
              />
              <div
                className="relative w-16 h-16 md:w-20 md:h-20 rounded-2xl flex items-center justify-center shadow-lg"
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  backdropFilter: 'blur(8px)',
                  animation: 'float 3s ease-in-out infinite',
                }}
              >
                <span
                  className="text-3xl md:text-4xl font-black text-white"
                  style={{
                    textShadow: '0 0 20px rgba(251, 191, 36, 0.8), 0 2px 8px rgba(251, 191, 36, 0.5)',
                    animation: 'float 3s ease-in-out infinite',
                  }}
                >
                  M
                </span>
              </div>
              {/* Particules dorées */}
              <div
                className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-amber-400"
                style={{ animation: 'sparkle 2s ease-in-out infinite' }}
              />
              <div
                className="absolute -bottom-1 -left-1 w-2 h-2 rounded-full bg-amber-300"
                style={{ animation: 'sparkle 2s ease-in-out infinite 0.7s' }}
              />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold">Carnet de Mesures</h1>
              <p className="text-blue-100 text-sm">Version {APP_VERSION}</p>
            </div>
          </div>
          <p className="text-lg text-blue-100 max-w-xl leading-relaxed">
            L'application professionnelle des tailleurs et couturières pour gérer clients, mesures et commandes avec facilité.
          </p>
          <div className="flex flex-wrap gap-3 mt-6">
            {['Hors-ligne', 'Sécurisé', 'Multi-appareils', 'Dashboard'].map((tag, i) => (
              <span key={i} className="px-3 py-1 bg-white/20 backdrop-blur rounded-full text-sm font-medium hover:bg-white/30 transition-colors cursor-default">
                {tag}
              </span>
            ))}
          </div>
        </div>
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/20 backdrop-blur hover:bg-white/30 hover:scale-110 flex items-center justify-center transition-all duration-300"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Fonctionnalités principales */}
      <section className="mb-10">
        <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
          {Icons.sparkles}
          Pourquoi choisir Carnet de Mesures ?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <FeatureCard
            icon={Icons.users}
            title="Gestion des clients"
            description="Ajoutez, modifiez et recherchez vos clientes facilement. Toutes les informations au même endroit."
          />
          <FeatureCard
            icon={Icons.ruler}
            title="Mesures précises"
            description="Prenez et enregistrez les mesures pour tous types de vêtements : robes, hauts, pantalons, etc."
          />
          <FeatureCard
            icon={Icons.offline}
            title="Mode hors-ligne"
            description="Travaillez sans connexion internet. Vos données restent accessibles partout, tout le temps."
          />
          <FeatureCard
            icon={Icons.cloud}
            title="Synchronisation cloud"
            description="Sauvegardez vos données sur le serveur et retrouvez-les sur tous vos appareils."
          />
          <FeatureCard
            icon={Icons.phone}
            title="Application mobile"
            description="Installez l'app sur votre téléphone comme une vraie application native."
          />
          <FeatureCard
            icon={Icons.shield}
            title="Sécurité garantie"
            description="Vos données sont privées et protégées. Paiements sécurisés via FedaPay."
          />
          <FeatureCard
            icon={Icons.dashboard}
            title="Docs Professionnels"
            description="Éditez des reçus A6 et bons de commande premium au format PDF."
          />
          <FeatureCard
            icon={Icons.clipboard}
            title="Suivi commandes"
            description="Gérez les commandes, échéances et paiements directement depuis chaque mesure."
          />
          <FeatureCard
            icon={Icons.bell}
            title="Tableau de bord"
            description="Statistiques clients, revenus, commandes et évolution de votre activité."
          />
        </div>
      </section>

      {/* Téléchargement APK */}
      <section className="mb-10 relative overflow-hidden rounded-3xl bg-emerald-600 p-6 md:p-10 text-white shadow-xl">
        <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 bg-white/10 rounded-full blur-3xl" />
        <div className="relative flex flex-col md:flex-row items-center gap-8">
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-white/20 backdrop-blur-md flex items-center justify-center shrink-0 shadow-lg">
            {Icons.android}
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl font-bold mb-3">Application Android Native</h2>
            <p className="text-emerald-50 mb-6 max-w-lg">
              Pour une expérience plus fluide et stable sur Android, nous vous recommandons d'installer l'application native directement sur votre téléphone.
            </p>
            <div className="flex flex-wrap justify-center md:justify-start gap-4">
              <a
                href={apkUrl || "https://mesurette.com/app/carnet-mesures.apk"}
                className="inline-flex items-center gap-3 bg-white text-emerald-700 px-6 py-3 rounded-xl font-bold hover:bg-emerald-50 transition-all hover:scale-105 shadow-lg"
              >
                {Icons.download}
                Télécharger l'APK
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Forfaits */}
      <section className="mb-10">
        <h2 className="text-xl font-bold text-gray-800 mb-6">Nos forfaits</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 pt-4">
          <PlanCard
            name="Gratuit"
            price="0 FCFA"
            features={['3 clients maximum', 'Mesures illimitées', 'Mode hors-ligne']}
          />
          <PlanCard
            name="Starter"
            price="250 FCFA/mois"
            features={['50 clients', '50 Mo stockage', 'Synchronisation cloud']}
          />
          <PlanCard
            name="Essentiel"
            price="2 500 FCFA/6 mois"
            features={['200 clients', '100 Mo stockage', 'Export PDF/CSV', 'Bons de Commande', 'Dashboard statistiques']}
            highlight
            promo="🔥 -40%"
          />
          <PlanCard
            name="Pro"
            price="5 000 FCFA/an"
            features={[
                '1 000 clients', 
                '500 Mo stockage', 
                'Reçus & Bons (Premium)', 
                'Reçu Rapide (1-clic)',
                'Suivi des commandes', 
                'Dashboard & Notifications'
            ]}
            promo="⭐ -50%"
          />
        </div>
      </section>

      {/* Comment ça marche */}
      <section className="mb-10 bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 border border-gray-100">
        <h2 className="text-xl font-bold text-gray-800 mb-6">Comment ça marche ?</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {[
            { step: '1', title: 'Inscrivez-vous', desc: 'Créez votre compte avec votre téléphone' },
            { step: '2', title: 'Ajoutez vos clients', desc: 'Enregistrez vos clientes avec leurs infos' },
            { step: '3', title: 'Prenez les mesures', desc: 'Notez toutes les mensurations' },
            { step: '4', title: 'Synchronisez', desc: 'Sauvegardez dans le cloud' },
          ].map((item, i) => (
            <div key={i} className="text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 text-white font-bold text-xl flex items-center justify-center shadow-lg">
                {item.step}
              </div>
              <h4 className="font-semibold text-gray-800 mt-3">{item.title}</h4>
              <p className="text-sm text-gray-600 mt-1">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="mb-10 bg-white rounded-2xl p-6 border border-gray-100 shadow-sm">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Questions fréquentes</h2>
        <div className="divide-y divide-gray-100">
          {faqs.map((faq, i) => (
            <FAQItem key={i} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </section>

      {/* Témoignages */}
      <section className="mb-10">
        <h2 className="text-xl font-bold text-gray-800 mb-6">Ce que disent nos utilisateurs</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[
            { name: 'Marie A.', role: 'Couturière', text: 'Cette application a transformé mon travail ! Je ne perds plus jamais les mesures de mes clientes.' },
            { name: 'Kokou M.', role: 'Tailleur', text: "Même sans connexion au marché, je peux consulter toutes mes fiches. C'est vraiment pratique !" },
          ].map((testimonial, i) => (
            <div key={i} className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm">
              <div className="flex gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star}>{Icons.star}</span>
                ))}
              </div>
              <p className="text-gray-700 italic mb-4">"{testimonial.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-indigo-500 flex items-center justify-center text-white font-bold">
                  {testimonial.name[0]}
                </div>
                <div>
                  <p className="font-semibold text-gray-800">{testimonial.name}</p>
                  <p className="text-xs text-gray-500">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact & Propriété */}
      <section className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-6 md:p-8 text-white">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="font-bold text-lg mb-4">Propriété</h3>
            <p className="text-gray-300 mb-2">
              Cette application est développée et maintenue par <strong className="text-white">EXPONENTIEL</strong>.
            </p>
            <p className="text-gray-400 text-sm">
              Innovation numérique au service des artisans africains.
            </p>
          </div>
          <div>
            <h3 className="font-bold text-lg mb-4">Contactez-nous</h3>
            <div className="space-y-3">
              <a
                href="mailto:exponentiel29@gmail.com?subject=Carnet%20de%20Mesures"
                className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                exponentiel29@gmail.com
              </a>
              <a
                href="https://wa.me/2290198538343"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-green-600 hover:bg-green-500 px-4 py-2 rounded-full transition-colors"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                WhatsApp: +229 01 98 53 83 43
              </a>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-700 text-center text-gray-400 text-sm">
          © {new Date().getFullYear()} EXPONENTIEL. Tous droits réservés. • Carnet de Mesures v{APP_VERSION}
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
